// Supabase REST API client - uses same instance as main app
const SUPABASE_URL = "https://ewtvvwayiyumlemenceq.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3dHZ2d2F5aXl1bWxlbWVuY2VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MjIwODUsImV4cCI6MjA5MzM5ODA4NX0.eiaIryB6mvQeP3N714pAXwGqvR8FyUWmi5LxdiJHZxw";

export const sbFetch = async (method, table, payload = null, headers = {}) => {
  const url = `${SUPABASE_URL}/rest/v1/${table}`;

  const requestHeaders = {
    "Content-Type": "application/json",
    apikey: SUPABASE_KEY,
    Authorization: `Bearer ${SUPABASE_KEY}`,
    ...headers,
  };

  const options = { method, headers: requestHeaders };
  if (payload) options.body = JSON.stringify(payload);

  try {
    const res = await fetch(url, options);
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(`Supabase error: ${res.status} - ${JSON.stringify(errorData)}`);
    }

    // Handle 204 No Content
    if (res.status === 204) return null;

    // Handle empty response
    const text = await res.text();
    if (!text || text === "[]") return null;

    try {
      const data = JSON.parse(text);
      return data;
    } catch (parseError) {
      console.warn("Could not parse response:", text);
      return null;
    }
  } catch (e) {
    console.error("sbFetch error:", e);
    throw e;
  }
};

export const sbGetSetting = async (key) => {
  try {
    const url = `${SUPABASE_URL}/rest/v1/app_settings?key=eq.${encodeURIComponent(key)}&select=value`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
      },
    });

    if (!res.ok) {
      console.warn(`Could not load setting ${key}: ${res.status}`);
      return null;
    }

    // Handle empty response
    const text = await res.text();
    if (!text || text === "[]") {
      return null;
    }

    const data = JSON.parse(text);
    if (Array.isArray(data) && data.length > 0) {
      return JSON.parse(data[0].value);
    }
    return null;
  } catch (e) {
    console.warn(`Could not load setting ${key}:`, e);
    return null;
  }
};

export const sbSetSetting = async (key, val) => {
  try {
    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/app_settings?on_conflict=key`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_KEY,
          Authorization: `Bearer ${SUPABASE_KEY}`,
          Prefer: "resolution=merge-duplicates,return=minimal",
        },
        body: JSON.stringify({
          key,
          value: JSON.stringify(val),
          updated_at: new Date().toISOString(),
        }),
      }
    );

    if (!res.ok && res.status !== 201) {
      throw new Error(`Supabase error: ${res.status}`);
    }

    // Don't try to parse empty response (return=minimal)
    return null;
  } catch (e) {
    console.error(`Could not save setting ${key}:`, e);
    throw e;
  }
};
